import React from 'react'
import { Route, Switch } from 'react-router-dom'

const AppRouter = route => {
  return (
    <Switch>
      <Route
        path={route.match.path}
        render={routeProps => (
          <React.Fragment>
            {require('./AutoDebit').default(routeProps)}
            {require('./CallAppProcess').default(routeProps)}
            {require('./PaymentPriority').default(routeProps)}
            {require('./Result').default(routeProps)}
            {require('./Main').default(routeProps)}
            {require('./ServiceDetail').default(routeProps)}
          </React.Fragment>
        )}
      />
    </Switch>
  )
}

export default AppRouter
